export default {
    "Join broadcast": "Join broadcast",
}
